import { ObjectUtils } from '@jbt/utils';
import { Store, combineReducers } from '@ngrx/store';
import { ReducersRepository } from '../reducers-repository';
import { ReducerConfiguration } from '../reducer-configuration';

export class ReducersConfigurator {

    private _store: Store<any>;
    private _reducersRepository: ReducersRepository;
    private _config: any = {};

    constructor(store: Store<any>, reducersRepository: ReducersRepository) {
        this._store = store;
        this._reducersRepository = reducersRepository;
    }

    public addReducers(config: ReducerConfiguration): void {

        this._config[config.id] = (this._config[config.id])
            ? ObjectUtils.mergeTrees( this._config[config.id], config )
            : config;

        Object.keys(this._config).forEach( key => this._addReducer(this._config[key]) );
    }


    private _addReducer(reducerConfig): void {

        this._store.addReducer(
            reducerConfig.id,
            this._createReducerFn(reducerConfig)
        );
    }

    private _createReducerFn(config: any): any  {

        return (config.children)
            ? this._createReducersByConfig( config.children )
            : (state, action) => this._mainReducer(state, action, config);
    }

    private _createReducersByConfig(config: any[] = [] ): any {

        const self = this;

        return combineReducers(
            config.reduce( (reducers, item) => {
                reducers[item.id] = self._createReducerFn(item);
                return reducers;
            }, {})
        );
    }

    public _mainReducer(state, action, config): Function {

        if (!state) {
            return config.initialState;
        }

        config.handlers = config.handlers || {};

        const handler = this._getReducerHandlers( config.handlers[action.type] );

        return handler(state, action);
    }

    private _getReducerHandlers(handler: string | Function): Function {

        return (typeof handler === 'function')
            ? handler
            : this._reducersRepository.get( handler );
    }

}
